import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import CSSModules from 'react-css-modules';
import styles from './archives.css';
import cloneDeep from 'lodash/cloneDeep';
import { compose } from 'redux';
import * as resolve from 'table-resolver';
import * as Table from 'reactabular-table';
import * as tree from 'treetabular';

import { EV_RELEASES } from 'constants.js';
import { FR_RELEASES } from 'constants.js';
import { LTS_RELEASE } from 'constants.js';
import { LTS_VERSION } from 'constants.js';
import { FR_VERSION } from 'constants.js';
import { LOCALE } from 'utils/environment';

import Translate from 'utils/translate';

class Archives extends React.Component {
  constructor(props) {
    super(props);
    
    /**  
     * Indicates whether the table has been built since the page was first loaded.
     * This is set to false by default. Once the table has been built, any user input
     * on the page will change the value to to true.
     */
    this.state = {
      tableBuilt: false
    };      
  }
  
  /**
   * Reactabular requires that child entries are directly below their parent entries.
   * Rows are sorted by 'id'. Each child entry 'id' is uniquely generated to situate the row 
   * below the parent when the rows are sorted.
   */ 
  sortRows(rows, productTree, version) {
    let filteredRowsbyVersion = rows.filter(row => {
      return row.majorMinor === version;
    });

    let filteredTree = productTree.filter(tree => {
      return tree.majorMinor === version;
    });

    // Get the set of unique platforms to filter by
    let platformFilters = new Set();
    filteredTree.forEach(entry => {
      platformFilters.add(entry.platform);
    })

    platformFilters = Array.from(platformFilters).sort();

    // Create an array of arrays by platform 
    let filteredPlatforms = [];
    platformFilters.forEach(platform => {
      let filteredRowsbyPlatform = filteredRowsbyVersion.filter(row => {
        return row.platform === platform
      })
      if (filteredRowsbyPlatform.length > 0) {
        filteredPlatforms.push(filteredRowsbyPlatform)

      }
    })
    
    // Reverse sort each platform array to place releases in descending order
    let sortedRows = [];
    filteredPlatforms.forEach(platformRows =>{
      let sRows = platformRows.sort(function(a, b) {
        let idA = a.id.toUpperCase();
        let idB = b.id.toUpperCase();
        
        // Use a numeric sort on the entry id to ensure the correct order in the table
        return idB.localeCompare(idA, undefined, { numeric: true, sensitivity: 'base' });
      });
      sortedRows.push(sRows)
    })      
    
    /** Remove a set number of releases of every product for the current LTS_VERSION or FR version
     * to avoid overlap with releases on the LTS or FR tab. Also remove any empty platform
     * or product branches that are created as a result.
     */

    if (version === LTS_RELEASE[0] || version === "12 (FR)") {
      let platformsToRemove = [];

      sortedRows.forEach(row => {
        let platformName = row[0].platform;
        const windowsTransforms = [
          'WindowsAgent',
          'WindowsManager',
          'WindowsNotifier',
          'WindowsRelay',
        ];
        
        if (windowsTransforms.includes(platformName)) {
          platformName = 'Windows';
        }

        if (row.length === 0) {
          platformsToRemove.push(platformName);
        }
      });

      // Remove platform branches that have no releases
      let indexAdjustment = 0
      let filteredTreeClone = [...filteredTree]
      filteredTree.forEach (function(branch, index) {
        let platformName = branch.platform ? branch.platform : ''
        if (platformsToRemove.indexOf(platformName) !== -1) {
          filteredTreeClone.splice(index + indexAdjustment, 1)
          indexAdjustment += -1
        }
      })

      // Count how many times each product appears in the filtered results
      let productCount = {}
      filteredTreeClone.forEach(branch => {
        if (branch.product) {
          if (productCount[branch.product]) {
            productCount[branch.product] += 1
          } else {
            productCount[branch.product] = 1
          }

        }
      })

      // Remove any product branches that have no platforms
      let filteredTreeCloneClone = [...filteredTreeClone]
      let indexAdjustmentClone = 0
      filteredTreeClone.forEach(function(branch, index) {
        if (productCount[branch.product]) {
          if (productCount[branch.product] === 1) {
            filteredTreeCloneClone.splice(index + indexAdjustmentClone, 1)
            indexAdjustmentClone += -1  
          }
        }
      })

      filteredTree = filteredTreeCloneClone
    }

    // Sort the rows that are used to build the tree
    let sortedTree = filteredTree.sort(function(a, b) {
      let idA = a.id.toUpperCase();
      let idB = b.id.toUpperCase();

      // Use a numeric sort on the entry id to ensure the correct order in the table
      return idA.localeCompare(idB, undefined, { numeric: true, sensitivity: 'base' });
    });

    // Once the tree is sorted, change productData value back to "Windows" for Windows + platform entries 
    sortedTree.forEach(entry =>{
      let productData  = entry.productData
      if (productData.includes("Windows")) {
        entry.productData = "Windows";
        }
    })

    // Add the reverse sorted platform arrays under the parent entry in the tree
    let indexAdjustment = 0;
    let sortedTreeClone = [...sortedTree] 

    /** sortedTree is iterated over to obtain the insertion point of each 
     * reverse sorted platform arrays, but the actual insertion is done
     * to sortedTreeClone in order to maintain the proper index position of sortedTree
     */
    sortedTree.forEach(function(treeRow, index) {
      sortedRows.forEach(platform => {
        if (platform.length > 0 && platform[0].parent === treeRow.id) {
          sortedTreeClone.splice(index + 1 + indexAdjustment, 0, ...platform);
          indexAdjustment += platform.length
        }
      })     
    })
    return sortedTreeClone;
  };


  /**
   * Dynamically builds the tree hierarchy for all Deep Security products:
   * 
   * 'Deep Security' (manually  generated)
   *    version
   *      product
   *        platform
   */ 
  buildProductTree(productTree) {
    let formattedProductTree = []

    productTree.forEach(entry =>{
      let productData = entry.split(",") 
      let formattedVersion = productData[0]  // Used in creating the entry ID
      
      // Modify product entry version so that it sorts correctly in the tree hierarchy  
      if (productData[0] === "9.0" ||
          productData[0] === "9.5" ||
          productData[0] === "9.6" ||
          productData[0] === "6.0") {
        formattedVersion = "0" + formattedVersion
      }    
      if (productData[0] === FR_VERSION) {
        productData[0] = "12 (FR)"
        formattedVersion = "12 (FR)"
      }

      if (productData[0] === "11.3") {
        productData[0] = "11.3 (FR)"
        formattedVersion = "11.3 (FR)"
      }      

      let releaseType = '';
      if (FR_RELEASES.includes(formattedVersion)) {
        releaseType = "Feature Releases (FR)"
      }

      if (productData[0] === LTS_VERSION) {
//         releaseType = "Long Term Support Release 12 (LTS)"
//         productData.shift()
        productData[0] = LTS_RELEASE[0]
        formattedVersion = LTS_RELEASE[0]
      }

      if (productData.length === 1) {

        formattedProductTree.push(
          {
            id: "Deep-Security" + releaseType + formattedVersion,
            productData: productData[0],
            software: "",
            displayName: "",
            releaseType: "",
            releaseDate: "",
            build: "",
            releaseNotes: "",
            SHA256: "",
            parent: "Deep-Security" + releaseType,
            majorMinor: productData[0]
          }
        )
      } else if (productData.length === 2) {
        formattedProductTree.push(
          {
            id: "Deep-Security" + releaseType + formattedVersion + productData[1],
            productData: productData[1],
            software: "",
            displayName: "",
            platform: "",
            releaseType: "",
            releaseDate: "",
            build: "",
            product: productData[1],
            releaseNotes: "",
            SHA256: "",
            parent: "Deep-Security" + releaseType + formattedVersion,
            majorMinor: productData[0]
          }
        )                
      } else if (productData.length === 3) {
        if (productData[2] === "ESX") {
          productData[2] = "ESXi"
        }     
        if (productData[2] === "Windows") {
          productData[2] = "Windows" + productData[1]
        }              
        formattedProductTree.push(
          {
            id: "Deep-Security" + releaseType + formattedVersion + productData[1] + productData[2],
            productData: productData[2],
            software: "",
            platform: productData[2],            
            releaseType: "",
            releaseDate: "",
            build: "",
            product: productData[1],
            releaseNotes: "",
            SHA256: "",
            parent: "Deep-Security" + releaseType + formattedVersion + productData[1],
            majorMinor: productData[0]
          }
        )                
      }
    })

    return formattedProductTree;
  }

  // Create the columns for the table
  getColumns() {

    return (
      [
        {
          property: 'productData',
          header: {
            label: 'Product',
            formatters: [
              productData => (
                <Translate stringID="thead.product" defaultValue="Product" />
              )
            ]
          },
          props: {
            style: { "min-width": 300 }
          },            
          cell: {
            /** 
             * The 'tree.toggleChildren' formatter filters rows from view by switching the showingChildren
             * property of each row between true and false.
             */
            formatters: [
              tree.toggleChildren({
                getRows: () => this.state.rows,
                getShowingChildren: ({ rowData }) => rowData.showingChildren,
                toggleShowingChildren: rowIndex => {
                  const rows = cloneDeep(this.state.rows);

                  rows[rowIndex].showingChildren = !rows[rowIndex].showingChildren;

                  this.setState({ rows });
                },
              }),
            ]
          }
        },            
        {
          property: 'software',
          header: {
            label: 'Software',
            formatters: [
              software => (
                <Translate stringID="thead.software" defaultValue="Software" />
              )
            ]
          },
          cell: {
            /** 
             * The cell formatter checks each release to see if it has been marked for removal.
             * There are two states for a removed release. If the '(removed)' string is appended
             * to 'software' without a KB link, the KB article explaining the reason for the removal
             * isn't yet available, and the release is made unavailable for download.
             * If 'software' has the string '(removed)' and a KB link appended, the KB article link
             * text is available and the link to the KB is also added inside a cautionary note.
             */
            formatters: [
              software => (
                software.includes('(removed)') === false
                ? <a href ={software} >{software.split("/").pop()}</a>
                : software.includes('https://success.trendmicro.com') === true
                  ? <div>
                    <span>{software.split(",")[0].split("/").pop().slice(0, -9)}</span>
                      <br></br>
                      <p><em>Note: Use of this release is not recommended. Please see <a href={software.split(",")[1]}>KB{software.split(",")[1].split("/").pop()}</a> for more information.</em></p>
                    </div>
                  : <span>{software.split(",")[0].split("/").pop().slice(0, -9)}</span>
              )
            ]
          },
        },
        {
          property: 'displayName',
          header: {
            label: 'Display Name',
            formatters: [
              displayName => (
                <Translate stringID="thead.displayName" defaultValue="Display Name" />
              )
            ]
          },
          props: {
            style: { "min-width": 135 }
          }, 
        },
        {
          property: 'releaseType',
          header: {
            label: 'Release Type',
            formatters: [
              releaseType => (
                <Translate stringID="thead.releaseType" defaultValue="Release Type" />
              )
            ]
          }
        },
        {
          property: 'releaseDate',
          header: {
            label: 'Release Date',
            formatters: [
              releaseDate => (
                <Translate stringID="thead.releaseDate" defaultValue="Release Date" />
              )
            ]
          }
        },
        {
          property: 'build',
          header: {
            label: 'Build',
            formatters: [
              build => (
                <Translate stringID="thead.build" defaultValue="Build" />
              )
            ]
          }
        },
        {
          property: 'minimumDsmVersionRequired',
          header: {
            label: 'Minimum DSM Version',
            formatters: [
              build => (
                <div><Translate stringID="thead.minimumDsmVersionRequired" defaultValue="Minimum DSM Version" /><a href="#min_dsm_version"><strong> (<sup>1</sup>)</strong></a></div>
              )
            ]
          }
        },        
        {
          property: 'releaseNotes',
          header: {
            label: 'Release Notes',
            formatters: [
              releaseNotes => (
                <Translate stringID="thead.releaseNotes" defaultValue="Release Notes" />
              )
            ]
          },
          cell: {
            /** 
             * Checks if the releaseNotes URL includes the https://success.trendmicro.com domain,
             * which indicates that the release was removed. If the domain is found, changes the link text to the KB number
             * that describes the reason for pulling the release.        
             */
            formatters: [ 
              releaseNotes => (
                releaseNotes !== "" 
                ? <a href ={releaseNotes} >{releaseNotes.includes("https://success.trendmicro.com") ? "KB" + releaseNotes.split("/").pop() : <Translate stringID="text.releaseNotes" defaultValue="Release Notes" />}</a>
                : null
              )
            ]
          },
        },        
        {
          property: 'SHA256',
          header: {
            label: 'SHA256',
            formatters: [
              SHA256 => (
                <Translate stringID="thead.sha256" defaultValue="SHA256" />
              )
            ]
          }
        }
      ]
    )
  }

  /**
   * Using the product data passed from software-feed.js, the getRows function creates an object 
   * for each product entry that contains all the needed fields to render and sort it correctly.
   */
  getRows(products) {
    let processedRows = [];
    products.forEach(product => {
      processedRows.push(product.cards.map(function(row, index) {
        
        // Modify entries with 'ESX' as the platform to 'ESXi'.
        if (row.platform === "ESX") {
              row.platform = "ESXi"
        };        
        
        // Modify entries with 'GM' as the releaseType to show as GA (GM is an internal term).
        if (row.releaseType) {
          if (row.releaseType === "GM") {
            row.releaseType = "GA";
          }
        }      
        if (row.platform === "Windows") {
          row.platform = "Windows" + row.product
        }
    
        // Modify entries with 'GM' in the releaseName to show as GA (GM is an internal term).
        if (row.releaseName) {
          let regexGM = /(.*?)(\.\d)(_GM)/;
          let regexUpdate = /(.*?)(\.\d)(_U)(.*?)/;
          if (regexGM.test(row.releaseName) === true) {
            row.releaseName = row.releaseName.replace(regexGM, "$1$2 GA");
          }
          if (regexUpdate.test(row.releaseName) === true) {
            row.releaseName = row.releaseName.replace(regexUpdate, "$1$2 LTS Update $4");
          }
        }
                 
        let formattedVersion = row.majorMinor
        if (row.majorMinor === "9.0" ||
            row.majorMinor === "9.5" ||
            row.majorMinor === "9.6" ||
            row.majorMinor === "6.0") {
          formattedVersion = "0" + formattedVersion
        }

        if (formattedVersion === FR_VERSION) {
            formattedVersion = "12 (FR)"
            row.majorMinor = "12 (FR)"
        }

        if (formattedVersion === "11.3") {
            formattedVersion = "11.3 (FR)"
            row.majorMinor = "11.3 (FR)"
        }

        let releaseType = '';  // Used in creating the entry ID
        if (FR_RELEASES.includes(formattedVersion)) {
          releaseType = "Feature Releases (FR)"
        }

        if (formattedVersion === LTS_VERSION) {
          formattedVersion = LTS_RELEASE[0]
          row.majorMinor = LTS_RELEASE[0]

        }
        
        /** 
         * Appends '(removed)' string to row.download if row.disabled is 'true', as well as a KB article URL if present in row.disabled.
         * The getColumn() function checks for these string values when formatting a removed release in the table.
         */
        let formattedDownload = row.download; // Create a formatted version of row.download to use for removed releases
        if (row.disabled && row.disabled === true) {
          formattedDownload = row.download + " (removed)";
          // row.download = row.download + " (removed)";
        } else if (row.disabled &&  row.disabled.includes("http") === true ) {
          formattedDownload = row.download + " (removed)" + ',' + row.disabled;
          // row.download = row.download + " (removed)" + ',' + row.disabled;
        }
        
        if (row.releaseType === "Feature Release") {
            row.releaseType = "Feature Releases (FR)"
        }        
        return {
          /** 
           * Reactabular's tree module uses the unique 'id' generated below
           * to sort each product entry into the correct part of the tree.
           */
          id: "Deep-Security" + releaseType + formattedVersion + product.name + row.platform + row.download.split('/').pop(),
          product: "",
          productData: "",
          software: formattedDownload,
          displayName: row.releaseName,
          releaseType: row.releaseType,
          releaseDate: row.releaseDate,
          majorMinor: row.majorMinor,
          buildNumber: row.buildNumber,
          minimumDsmVersionRequired: row.minimumDsmVersionRequired,
          platform: row.platform,
          product: row.product,
          build: row.release,
          releaseNotes: row.releaseNotes,
          SHA256: row.sha256,
          parent: "Deep-Security" + releaseType + formattedVersion + product.name + row.platform,
        }
      }));
    });

    // Merge rows for all products into a single array for formatting by Reactabular
    processedRows = [].concat.apply([], processedRows);

    return processedRows;
  }

  render() {
    /**
     * Check if the Redux store has been updated with the formatted XML feed data (productTree) from software-feed.js,
     * and if the table has already been built (tableBuilt). If 'productTree' exists and 'tableBuilt' is false, 
     * format the row and column data for the table. This check is needed to ensure that user interaction with an exisitng table
     * doesn't cause the row data to be rebuilt and interfere with row expansion and searching.
     */
    if (this.props.productTree && this.state.tableBuilt === false) {
      const products = this.props.products;

      // Create the hierarchy for the product tree structure
      let productTree = this.buildProductTree(this.props.productTree);
      let treeTop = [
        {
          id: "Deep-Security",
          productData: "Deep Security",
          software: "",
          displayName: "",
          releaseType: "",
          releaseDate: "",
          build: "",
          releaseNotes: "",
          SHA256: "",
          showingChildren: true
        }      
      ]

      let FRTop = [
        {
          id: "Deep-Security" + "Feature Releases (FR)",
          productData: "Feature Releases (FR)",
          software: "",
          displayName: "",
          releaseType: "",
          releaseDate: "",
          build: "",
          releaseNotes: "",
          SHA256: "",
          parent: "Deep-Security",
        }, 
      ]
    
      const columns = this.getColumns();
      let rows = this.getRows(products);

      let allRows = [];
      allRows.push(treeTop);
      LTS_RELEASE.forEach(version => {
        allRows.push(
          this.sortRows(rows, productTree, version));
        });
        
      if (LOCALE === "en-us") {
        allRows.push(FRTop);        
        FR_RELEASES.forEach(version => {
          allRows.push(
            this.sortRows(rows, productTree, version));
          });
      }
 
      EV_RELEASES.forEach(version => {
        allRows.push(
          this.sortRows(rows, productTree, version));
        }); 
      
      // Merge the product tree hieracrhy entries and product entries into a single array for Reactabular to process.
      rows = [].concat.apply([], allRows);
      rows = resolve.resolve({columns})(rows);
      
      // Save the column and row data, and table status into the Archive component state.
      this.state = {
        rows,
        columns,
        tableBuilt: true,
      };
    }

    // If 'productTree' exists, build the table using all the data stored in the Archive component state.
    if (this.props.productTree) {
      const {query, columns} = this.state;
      const rows = compose(
         tree.filter({ fieldName: 'showingChildren' })
      )
      (this.state.rows);

      return (
        <div>
          <Table.Provider
            columns={columns}
          >
            <Table.Header />
  
            <Table.Body rows={rows} rowKey="id" />
          </Table.Provider>
        </div>
      );
    }
  }
}
  

Archives.propTypes = {
  products: PropTypes.array.isRequired,
};

const mapStateToProps = state => ({
  products: state.softwareFeed.products,
  productTree: state.softwareFeed.productTree,
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(Archives, styles)); // CSSModules isn't used to style the table; the Reactabular table styles are in HelpCenter-V3.css.